module.exports = __webpack_public_path__ + "img/cattunnel24.31bacf19.jpg";